import React from 'react';
import seoGlobals from '../seo_globals.json';
import SEOPage from '../components/SEOPage';

const Locations: React.FC = () => {
    const address = seoGlobals.contact.address;

    return (
        <div className="pt-32 pb-40 bg-vanity-white">
            <SEOPage
                title="Standorte | VANITY"
                description={seoGlobals.seo.defaultDescription}
            />
            <div className="max-w-[1200px] mx-auto px-8">
                <header className="text-center mb-16">
                    <span className="font-sans text-[11px] uppercase tracking-[0.5em] text-vanity-pink font-bold">Standorte</span>
                    <h1 className="font-serif text-5xl md:text-7xl text-vanity-black mt-6">VANITY Magazin</h1>
                    <p className="font-sans text-vanity-grey-dark mt-6 text-lg">
                        Unser zentraler Standort in Wien sowie ausgewählte Vertriebspartner in Österreich.
                    </p>
                </header>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
                    <div className="border border-vanity-charcoal/10 p-10 shadow-sm">
                        <h2 className="font-serif text-3xl text-vanity-black mb-4">Zentrale Wien</h2>
                        <p className="font-sans text-vanity-grey-dark leading-relaxed">
                            {address.street}<br />
                            {address.postalCode} {address.city}<br />
                            {address.country}
                        </p>
                        <p className="font-sans text-vanity-grey-dark mt-4">
                            Telefon: {seoGlobals.contact.phone}
                        </p>
                        <p className="font-sans text-vanity-grey-dark">
                            E-Mail: {seoGlobals.contact.email}
                        </p>
                        <a
                            href="https://maps.google.com/?q=Bankgasse+3+1010+Vienna"
                            target="_blank"
                            rel="noreferrer"
                            className="inline-block mt-6 text-[11px] uppercase tracking-[0.4em] text-vanity-pink font-bold"
                        >
                            Auf Google Maps ansehen
                        </a>
                    </div>
                    <div className="border border-vanity-charcoal/10 p-10 shadow-sm">
                        <h2 className="font-serif text-3xl text-vanity-black mb-4">Vertrieb & Partner</h2>
                        <p className="font-sans text-vanity-grey-dark leading-relaxed">
                            VANITY ist in ausgewählten Arztpraxen, Spas, Hotels und Premium-Zeitschriftenhandel in Österreich verfügbar.
                            Für Partnerschaften kontaktieren Sie unser Redaktionsteam.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Locations;